import { defineMessages } from 'react-intl';

export default defineMessages({
    confluencePage: {
        defaultMessage: 'Confluence page in {value}',
        description: 'Confluence page metadata text',
        id: 'cv.search.articles.metadata',
    },
});
